import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";
import { bankStatementLines } from "./bank-statement-lines";
import { accounts } from "./accounts";

// ============================================================================
// bank_statement_matches — confirmed reconciliation links and adjustments
// ============================================================================
export const bankStatementMatches = sqliteTable("accounting_bank_statement_matches", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  statementLineId: text("statement_line_id").notNull().references(() => bankStatementLines.id),
  matchType: text("match_type", {
    enum: ["exact", "split", "manual", "bank_fee", "writeoff", "suspense"],
  }).notNull(),
  targetType: text("target_type", {
    enum: ["payment", "receipt", "invoice", "journal_entry", "bank_fee", "writeoff", "suspense", "manual"],
  }).notNull(),
  targetId: text("target_id"),
  matchedAmount: real("matched_amount").notNull(),
  varianceAmount: real("variance_amount").notNull().default(0),
  adjustmentAccountId: text("adjustment_account_id").references(() => accounts.id),
  glSourceId: text("gl_source_id"),
  status: text("status", {
    enum: ["active", "reversed"],
  }).notNull().default("active"),
  matchedAt: text("matched_at").notNull(),
  matchedBy: text("matched_by"),
  reversedAt: text("reversed_at"),
  reversedBy: text("reversed_by"),
  reversalReason: text("reversal_reason"),
  notes: text("notes"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at"),
  updatedBy: text("updated_by"),
}, (table) => ({
  lineStatusIdx: index("bank_match_line_status_idx").on(table.statementLineId, table.status),
  targetIdx: index("bank_match_target_idx").on(table.companyId, table.targetType, table.targetId),
  targetStatusIdx: index("bank_match_target_status_idx").on(table.companyId, table.status, table.targetType, table.targetId),
  companyTypeIdx: index("bank_match_company_type_idx").on(table.companyId, table.matchType, table.status),
}));

export type BankStatementMatch = typeof bankStatementMatches.$inferSelect;
export type NewBankStatementMatch = typeof bankStatementMatches.$inferInsert;
